<template>
  <div>
    <div id="progress">
      <div v-bind:style="{ width: $store.state.progress + '%' }"></div>
    </div>
    <site-header v-if="!isFolder && !isShare && isMobileRegister && $route.name !== 'NewRecord' && $route.name !== 'Record' && $route.name !== 'Contact'" :style="headerStyle"></site-header>
    <sidebar v-if="!isFolder && !isShare && (hasPaymentMethod || $route.name === ROUTES.DRIVE) && $route.name !== 'NewRecord' && $route.name !== 'Record'"></sidebar>
    <main v-if="isReady" :style="payMethodStyle">
      <router-view></router-view>
      <shell v-if="isLogged && user.perm.execute" />
    </main>
    <banner v-if="permissions === 1 || permissionsSharedDrive === 1"></banner>
    <faldon v-if="selectedCount > 0"></faldon>
    <prompts></prompts>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import Sidebar from '@/components/Sidebar.vue';
import Prompts from '@/components/prompts/Prompts.vue';
import SiteHeader from '@/components/Header.vue';
import Shell from '@/components/Shell.vue';
import Banner from '../components/Banner.vue';
import Faldon from '../components/Faldon.vue';
import { ROUTES } from '../router';

export default {
  name: 'layout',
  data: function () {
    return {
      ROUTES,
      isReady: false
    };
  },
  components: {
    Sidebar,
    SiteHeader,
    Prompts,
    Shell,
    Banner,
    Faldon
  },
  computed: {
    ...mapGetters([ 'isLogged', 'isFolder', 'isShare', 'isRegister', 'isFiles', 'selectedCount', 'hasPaymentMethod' ]),
    ...mapState([ 'user', 'selected', 'permissions', 'permissionsSharedDrive', 'handleSharedDrive', 'isItemOptions', 'accountInfo' ]),
    isMobileRegister() {
      if (this.isRegister && this.isMobile()) {
        return true; 
      } else if (this.isRegister && !this.isMobile()) {
        return false;
      } else if (!this.isRegister) {
        return true;
      }
      return false;
    },
    payMethodStyle() {
      if ((!this.hasPaymentMethod && this.$route.name !== ROUTES.DRIVE) || this.isMobile()) {
        return {width: '100%'};
      } else if ((this.isFiles || this.$route.name === ROUTES.DRIVE) && !this.isTablet()) {
        return {width: 'calc(100% - 16em)', marginLeft: 'auto'};
      } else if ((this.isFiles || this.$route.name === ROUTES.DRIVE) && this.isTablet()) {
        return {width: 'calc(100% - 90px)', marginLeft: 'auto'};
      }
      return {};
    },
    headerStyle() {
      if ((!this.hasPaymentMethod && this.$route.name !== ROUTES.DRIVE) || this.isMobile()) {
        return {width: '100%'};
      } else if ((this.isFiles || this.$route.name === ROUTES.DRIVE) && !this.isTablet()) {
        return {width: 'calc(100% - 16em)', marginLeft: 'auto'};
      } else if ((this.isFiles || this.$route.name === ROUTES.DRIVE) && this.isTablet()) {
        return {width: 'calc(100% - 90px)', marginLeft: 'auto'};
      } 
      return {}; 
    }
  },
  watch: {
    '$route': async function () {
      await this.fetchData();
      if ((this.$route.name === ROUTES.SHARED_WITH_ME && this.$route.hash !== '') || this.$route.name === ROUTES.DRIVE) {
        this.checkPermissions();
      } else {
        this.setPermissionsSharedDrive(0);
      }
      this.$store.commit('resetSelected');
      this.$store.commit('multiple', false);
      if (this.$store.state.show !== 'success') this.$store.commit('closeHovers');
    }
  },
  async created () {
    const thisComponent = this;
    const JavaEventListenerClass = Module.EventListener.extend('EventListener', {
      onEvent: async function(event)
      {
        if (event.type == Module.EventType.ACCOUNT_INFO.value)
        {
          await thisComponent.fetchData();
          return;
        }

        if (event.type == Module.EventType.NEW_NODES.value && thisComponent.$route.name === ROUTES.SHARED_WITH_ME && thisComponent.$route.hash.replace('#', '') === event.node.handle) {
          thisComponent.checkPermissions();
        }

        if (event.type == Module.EventType.NEW_NODES.value || event.type == Module.EventType.DELETED_NODE.value)
        {
          await thisComponent.updateStorage();
        }

        return;
      }
    });

    this.interfaceObject = new JavaEventListenerClass();
    ibb.addEventListener(this.interfaceObject);
    await this.fetchData();
  },
  async mounted () {
    await this.updateStorage();
    if (this.$route.name === ROUTES.SHARED_WITH_ME && this.$route.hash !== '') {
      this.checkPermissions();
    } else if (this.$route.name === ROUTES.DRIVE) {
      await this.initializeLink();
    } else {
      this.setPermissionsSharedDrive(0);
      this.isReady = true;
    }
  },
  beforeDestroy () {
    ibb.removeEventListener(this.interfaceObject);
  },
  methods: {
    ...mapMutations(['setPermissions', 'setPermissionsSharedDrive', 'setHandleSharedDrive', 'setIsMaxStorage']),
    async fetchData() {
      if (this.isLogged) {
        try {
          this.setPermissions(this.accountInfo.accesslevel);
        } catch (e) {
          this.$showError(e);
        }
      }
    },
    async updateStorage() {
      if (this.isLogged) {
        try {
          if ((this.accountInfo.ustorage > this.accountInfo.tstorage) && (this.accountInfo.amount === 0)) {
            this.setIsMaxStorage(true);
          } else {
            this.setIsMaxStorage(false);
          }
        } catch (e) {
          this.$showError(e);
        }
      }
    },
    isMobile: function () {
      return window.innerWidth <= 768;
    },
    isTablet: function () {
      return (window.innerWidth <= 1024 && window.innerWidth >= 768);
    },
    async initializeLink() {
      let action = await ibbLink.loginLink(window.location.href);
      if (action.error.type) {
        this.$router.replace({path: '/shared-drive/my-drives'});
        window.history.go('/cloud');
        return;
        //throw new Error("Error logging to folder link: " + action.error.type)
      }

      if (!this.isLogged) {
        let lang = localStorage.getItem('lang');
        if (lang != 'es' && lang != 'en')
        {
            lang = '';
        }
        const user = JSON.parse('{"viewMode":"mosaic","locale":"' + lang + '"}');
        this.$store.commit('setUser', user);
      }
      
      action = await ibbLink.getNodes();
      if (action.error.type) {
        throw new Error('Error getting nodes from folder link: ' + action.error.type);
      }
      this.isReady = true;
      const sharedDrive = await ibbLink.getRootNode(0);
      this.setHandleSharedDrive(sharedDrive.node.handle);
      action = await ibbLink.getSharedDriveInfo(this.handleSharedDrive);
      this.setPermissionsSharedDrive(action.accountPermissions[0].accesslevel);
    },
    async checkPermissions() {
      let handle;
      if (this.$route.name === ROUTES.DRIVE) {
        const action = await ibbLink.getSharedDriveInfo(this.handleSharedDrive);
        this.setPermissionsSharedDrive(action.accountPermissions[0].accesslevel);
      } else {
        this.isReady = true;
        handle = this.$route.hash.replace('#', '');
        const action = await ibb.getSharedDriveInfo(handle);
        if (action.accountPermissions.length > 0) {
          this.setPermissionsSharedDrive(action.accountPermissions[0].accesslevel);
        }
      }
    }
  }
};
</script>
